module.exports = __webpack_public_path__ + "img/20180815_150609_088.d670c20f.jpg";